export default __webpack_public_path__ + "static/media/about-daffodils.f5607a2f.jpg";